module.exports = __webpack_public_path__ + "static/media/popular_white.6ab59d58.svg";